import '@fontsource/norwester';
import '@fontsource/vt323';

export const IMPACT_FONTS = ['Norwester', 'sans-serif'].join(',');

export const DIGITAL_FONTS = ['VT323', 'sans-serif'].join(',');
